const $$splitComponentImporter = () => import('/Users/xpress/Code/knrt/jgxt/projects/jgxt/ui/web/src/routes/sidebar.patient.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { type PatientArchive, type PatientArchiveHisExamReport, type PatientArchiveHisLabReport, type PatientArchivePeisExam } from '@/api/patient';
// 企业微信微信客服聊天工具栏「患者档案」侧边栏页面。
// 打开流程：企微静默授权登录 → JS-SDK 应用身份注册 → getCurExternalContact 取客户 → 定位患者并展示档案摘要。
// 视觉跟随小程序「健宫黄」品牌色：#F6AB04 / 深 #D98E00 / 浅底 #FFF7E6
export const Route = createFileRoute('/sidebar/patient')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
type Phase = {
  step: 'loading';
  text: string;
} | {
  step: 'ready';
  accountId: string;
} | {
  step: 'error';
  message: string;
};
// region 档案摘要渲染

// 详情视图目标：数据都在 archive 响应里，切换详情不发额外请求
type DetailTarget = {
  kind: 'lab';
  report: PatientArchiveHisLabReport;
} | {
  kind: 'exam';
  report: PatientArchiveHisExamReport;
} | {
  kind: 'peis';
  exam: PatientArchivePeisExam;
};

// endregion

// region 报告详情渲染

// endregion

// region 基础组件

// endregion

// region 工具函数

// sidebarErrorMessage 把 JS-SDK 与接口错误转成可操作的提示
// endregion
// SwipeRow 仅对可删除行启用左滑露出删除按钮,其他行直接透传内容
// endregion
// AI 巡查风险等级 → 徽章文案与色调
// 随访状态 → 徽章文案与色调, 已取消的不会出现在首页
// 复查提醒与随访卡片的统计范围说明
// 用户来源分类与条形配色, 顺序即展示顺序; 平台是「无院内记录」的兜底类, 用中性灰
// 各指标的口径说明, 集中放一处便于核对
// endregion
// 管理视角: 超管额外看到管理归属、覆盖、活跃趋势与功能使用; 健管师 / 运营员只看基础概览
// 超管的核心指标: 用真实的活跃与新增替代原先写死的两项 100%
// region 复查提醒与患者随访
// 管理视角和医生工作台共用, 统计范围由服务端按角色决定, 卡片描述里写明
// 上面一排底色统计格, 下面是近 7 天的明细列表
// endregion
// 用户来源分布: 横向条形, 全为 0(含数据未就绪)时按无数据占位
// 指标行:仿模板 KPI 行;纯数字走 KPI.Value,带 % 等符号的直接文本渲染
// endregion
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}